import React from 'react';

const MortgageAgeFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1372_8737)">
      <path
        d="M4.66665 14.9999L2.99998 13.3333L1.33331 14.9999"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 18.6666H4.33333C3.97971 18.6666 3.64057 18.5261 3.39052 18.2761C3.14048 18.026 3 17.6869 3 17.3333V13.3333"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_1372_8737)">
      <path d="M15.3333 5L17 6.66667L18.6666 5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M13.3333 1.33325H15.6666C16.0203 1.33325 16.3594 1.47373 16.6095 1.72378C16.8595 1.97382 17 2.31296 17 2.66659V6.66658"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path d="M12.876 11V12.5001" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.6274 11V12.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 15H18.5031" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <rect
      x="11.0001"
      y="11.877"
      width="7.50312"
      height="6.87786"
      rx="1"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g clipPath="url(#clip2_1372_8737)">
      <path
        d="M1.25 3.74992L5 0.833252L8.75 3.74992V8.33325C8.75 8.55427 8.6622 8.76623 8.50592 8.92251C8.34964 9.07879 8.13768 9.16659 7.91667 9.16659H2.08333C1.86232 9.16659 1.65036 9.07879 1.49408 8.92251C1.3378 8.76623 1.25 8.55427 1.25 8.33325V3.74992Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3.75 9.16667V5H6.25V9.16667" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1372_8737">
        <rect width="8" height="8" fill="white" transform="translate(0 12)" />
      </clipPath>
      <clipPath id="clip1_1372_8737">
        <rect width="8" height="8" fill="white" transform="translate(12)" />
      </clipPath>
      <clipPath id="clip2_1372_8737">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MortgageAgeFilterIcon;
